<script setup lang="ts">
import type { FusionSharedDtosMoodleStudentXpDto } from "~/types/api/api";

const props = defineProps<{
  item?: FusionSharedDtosMoodleStudentXpDto
}>()

const imageSrc = computed(() => {
  if (!props.item || !props.item.xp || !props.item.images || !props.item.images.length) return;
  const xp = props.item.xp;
  const index = props.item.images.findIndex(i =>
      i.minTik && i.maxTik &&
      i.minTik <= xp && xp <= i.maxTik)

  if (index > -1) {
    return `https://yasnet.yasanacademy.ir/local/gamification_badges/${props.item.images[index].path}`;
  }
})
</script>

<template>
  <VCard v-if="!!imageSrc" class="mb-4">
    <VCardText>
      <VImg :src="imageSrc" width="250px" class="mx-auto"/>
    </VCardText>
  </VCard>
</template>
